function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.127 317.328C181.213 331.057 172.837 342.291 163.514 342.291H49.3465C40.0233 342.291 31.6473 331.057 30.7339 317.328L12.722 46.6726C11.8086 32.9437 18.6899 21.7095 28.013 21.7095H184.848C194.171 21.7095 201.053 32.9427 200.139 46.6726L182.127 317.328Z",
  fill: "#22663D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M106 78V324H183L197 78H106Z",
  fill: "#1B4F30"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.916 21.7104C204.379 21.7104 212.861 34.2615 212.861 49.7424C212.861 65.2243 204.378 77.7743 193.916 77.7743H18.9446C8.48228 77.7753 0 65.2253 0 49.7424C0 34.2615 8.48228 21.7104 18.9446 21.7104H193.916Z",
  fill: "#22663D"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.547 22C208.32 22 213 34.5367 213 50C213 65.4643 208.32 78 202.547 78H106C106 59.9567 106 50.4676 106 50.4676C106 35.0043 106 38.9806 106 22H202.547Z",
  fill: "#1E5D36"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M143.938 153.755L122.146 115V115.001L90.4662 115.002L90.4653 115.001L71.5862 148.578L85.794 146.722L91.5801 160.891L106.463 134.424L123.985 165.584L113.695 171.684L143.019 175.517L154.448 147.525L143.938 153.755Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.7967 168.049L39 207.42L39.0027 207.419L54.8448 236.034V236.035H92.6096L83.9386 224.144L93 211.719H63.2297L80.7538 180.066L91.0444 186.262L79.6134 157.828L50.2851 161.72L60.7967 168.049Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.608 235.632H158.172L158.168 235.63L173.999 207.356H174L155.131 173.655L149.595 187.268L134.758 185.32L149.632 211.887H114.608V199.641L96.7241 223.89L114.609 248.138L114.608 235.632Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 213,
  height: 364,
  fill: "white"
})));

var SvgRecycleBin = function SvgRecycleBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 213,
    height: 364,
    viewBox: "0 0 213 364",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    clipPath: ""
  }, _ref2, _ref3, _ref4, _ref5, React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _ref6, _ref7, _ref8)), _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRecycleBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recycle-bin.00230e1c.svg";
export { ForwardRef as ReactComponent };